var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMunicipalservices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.886,
    height: 47.512,
    viewBox: "0 0 56.886 47.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-miterlimit:10;stroke-width:2px;}.a{stroke:#40b895;}.b{stroke:#4f4f4f;stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 20.233,
    transform: "translate(13.567 45.512)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 8.354,
    transform: "translate(20.641 37.158)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 8.354,
    transform: "translate(27.304 37.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M158.7,186.657a3.895,3.895,0,1,1-3.893-3.9A3.869,3.869,0,0,1,158.7,186.657Z",
    transform: "translate(-140.797 -171.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M149.166,223.793v3.4a4.963,4.963,0,0,1-4.948,4.948h-3.4a4.963,4.963,0,0,1-4.948-4.948v-3.4a4.972,4.972,0,0,1,3.406-4.7,3.89,3.89,0,0,0,6.2-.082A4.964,4.964,0,0,1,149.166,223.793Z",
    transform: "translate(-128.335 -201.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M136.46,182.658a6.2,6.2,0,0,1-5.623,3.609H98.116a6.213,6.213,0,0,1-6.2-6.2V162.726a6.213,6.213,0,0,1,6.2-6.2h21.105",
    transform: "translate(-91.92 -149.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M296.222,120.066v26.128H272.25V116.26h19.574Z",
    transform: "translate(-241.335 -116.26)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 14.558,
    transform: "translate(35.046 10.109)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 7.279,
    transform: "translate(35.046 14.968)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMunicipalservices);
export default __webpack_public_path__ + "static/media/municipalservices.c5fa4fa8d487756962e8ef8c56dcf5bd.svg";
export { ForwardRef as ReactComponent };